import { Optional } from '@/common/domain/Optional';

export const toBackendArray = <T, B>(array: Optional<T[]>, fromDomain: (t: T) => B): B[] | undefined => {
  if (array.isEmpty()) {
    return undefined;
  }

  return array.map(actualValues => actualValues.map(fromDomain)).orElseUndefined();
};
